import { createAction, props } from '@ngrx/store';
import { IActiveParsingResponse } from '../../interfaces/cv-parse';

export const checkActiveParsing = createAction(
  '[CV][Parse] check active parsing'
);

export const checkActiveParsingError = createAction(
  '[CV][Parse] check active parsing error'
);
  
export const checkActiveParsingSuccess = createAction(
  '[CV][Parse] check active parsing success',
  props<{ activeParsing: IActiveParsingResponse }>()
);

export const noActiveParsing = createAction(
  '[CV][Parse] no active parsing'
);

export const cancelActiveParsing = createAction(
  '[CV][Parse] cancel active parsing',
  props<{ cvId: number }>()
);

export const cancelActiveParsingSuccess = createAction(
  '[CV][Parse] cancel active parsing success'
);

export const cancelActiveParsingError = createAction(
  '[CV][Parse] cancel active parsing error'
);

export const uploadFileToParse = createAction(
  '[CV][Parse] upload file to parse',
  props<{ userId: string; cvFile: File }>()
);

export const uploadFileToParseSuccess = createAction(
  '[CV][Parse] upload file to parse success',
  props<{ activeParsing: IActiveParsingResponse }>()
);

export const uploadFileToParseError = createAction(
  '[CV][Parse] upload file to parse error'
);

export const getParsingResultForId = createAction(
  '[CV][Parse] get parsing result for id',
  props<{ cvId: number }>()
);

export const getParsingResultForIdNoResultYet = createAction(
  '[CV][Parse] get parsing result for id no result yet',
  props<{ cvId: number }>()
);

export const getParsingResultForIdSuccess = createAction(
  '[CV][Parse] get parsing result for id success',
  props<{ cvId: number }>()
);

export const getParsingResultForIdError = createAction(
  '[CV][Parse] get parsing result for id error'
);

export const resetParsingState = createAction(
  '[CV][Parse] reset parsing state'
);

export const updateRibbonShowState = createAction(
  '[CV][Parse] update ribbon show state',
  props<{ show: boolean }>()
);

export const updateRibbonFoldedState = createAction(
  '[CV][Parse] update ribbon folded state',
  props<{ folded: boolean;}>()
);

export const updateRibbonState = createAction(
  '[CV][Parse] update ribbon state',
  props<{ folded: boolean; show: boolean }>()
);
